module.exports = __webpack_public_path__ + "static/media/assessment-footer-image.5b5498a7.png";